import script from "./baseline-ignored-table.vue?vue&type=script&lang=ts&setup=true"
export * from "./baseline-ignored-table.vue?vue&type=script&lang=ts&setup=true"

import "./baseline-ignored-table.vue?vue&type=style&index=0&id=51db1db3&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51db1db3"]])

export default __exports__